var map = {
	"./ar-EG.json": 7267,
	"./de-DE.json": 2293,
	"./en-US.json": 6289,
	"./es-ES.json": 9245,
	"./fr-FR.json": 2814,
	"./id-ID.json": 9075,
	"./it-IT.json": 1503,
	"./ja-JP.json": 9665,
	"./ko-KR.json": 9138,
	"./pl-PL.json": 5492,
	"./pt-BR.json": 5332,
	"./ru-RU.json": 467,
	"./th-TH.json": 5258,
	"./tr-TR.json": 3960,
	"./vi-VN.json": 8559,
	"./zh-TW.json": 4127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4379;